import React from 'react';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink} from 'reactstrap';

import api from '../../api';
import './index.css';
export default class Example extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      hasUser: false,
      currentUser: {
        first_name: '',
        last_name: '',
      },
    };
  }
  componentDidMount() {
    if (api.getUser()) {
      this.setState({ hasUser: true });
    }
    this.getCurrentUser();
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  logout = () => {
    //eslint-disable-next-line
    const r = confirm('Are you sure to log out?');
    if (r) {
      Cookies.remove('access_token');
      Cookies.remove('email');
      Cookies.remove('user_id');
      this.setState({ hasUser: false });
      window.location.reload();
    }
  }
  getCurrentUser() {
    api.fetchAPI({
        method: 'get',
        uri: 'user/me',
        success: (response) => {
            if (response.status === 'ok') {
                this.setState({ currentUser: response.user })
            }
        },
        error: (error) => {
          console.error(error);
        }
    });
}
  render() {
    const { currentUser } = this.state;
    return (
      <div>
        <Navbar className="app-navigation-header" expand="md">
          <NavbarBrand className="app-navigation-header--home-logo" href="/">Customer Data Platform</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {currentUser &&
                <NavItem>
                  <NavLink className="app-navigation-header--avatar" href={`/me`}>
                    <div>
                      <span>{currentUser.first_name && currentUser.first_name.charAt(0) || 'D'}{currentUser.last_name && currentUser.last_name.charAt(0)}</span>
                    </div>
                  </NavLink>
                </NavItem>
              }
              <NavItem>
                <NavLink className="app-navigation-header--logout-button" onClick={() => this.logout()}>{this.state.hasUser ? 'Logout' : ''}</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/NavigationBar/index.js